module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAmElEQVQoU5XRMQ5BQRAG4G9E5SQuolEoxAEkEq3+9S4gUYgDuIFer3cWFCMryHsvT8RWu5n/m9nshj9XZOYYc2wj4tTlM3OEJXYFXDDEFdOIONZRZs5wQB/nAtaoXqEGaoVLpCogsMeijjCodS6lTUSsSlgHuqH3usYnXDZP8AW9S8/O78MHfEGNcGNCa9IE9/aLdYJf//gAiZI6ihqXn4sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-new/plan-down-white.png
// module id = oQqU
// module chunks = 4